import config from '../config';
import axios from "axios";
import * as utils from '../util/utils';

// console.log(config);
function qs(obj, prefix){
	var str = [];
	for (var p in obj) {
		var k = prefix ? prefix + "[" + p + "]" : p, 
		v = obj[p];
		str.push(typeof(v) == 'object' ? qs(v, k) : (k) + "=" + encodeURIComponent(v));
	}
	return str.join("&");
}

function admin(action, params, data){
	console.log('User config : ', config, data);
	var url = config.adminUrl.href+config.adminUrl.apis.user[action].path;
	if (params&&params.id){
		url = url + params.id;
	}
	var axiosOptions = {
		withCredentials: true,
		url : url,
		method : 'GET'
	}
	if (config.adminUrl.apis.user[action].method){
		axiosOptions.method = config.adminUrl.apis.user[action].method
	}
	if (data){
		axiosOptions.data = {data:data};
	}
	// console.log('xxxxx ', axiosOptions);
	return axios(axiosOptions);
}

function adminResource(source, params, data){
	console.log('Getting resource using : ', source);
	var url = config.apiUrl.href+config.adminUrl.apis[source].path;
	if (params&&params.id){
		url = url + params.id;
	}
	if (params&&params.filters){
		Object.keys(params.filters).forEach(function(key) {
			if (params.filters[key]){						
				if (Array.isArray(params.filters[key])){
					if (params.filters[key].length > 0){								
						var filters = [];
						params.filters[key].forEach(function(f){
							filters.push(f.value);
						});
						params.filter[key]={
							in : filters.join(',')
						};
					} else {
						if (params.filter[key]){
							delete params.filter[key];
						}
					}
				} else {
					if (params.filters[key].value){
						params.filter[key]=params.filters[key].value;
					} else {
						if (params.filters[key]){
							delete params.filter[key];
						}						
					}
				}
			} else {
				if (params.filter[key]){
					delete params.filter[key];
				}
			}
		});
		// console.log(resource, qs(params));
	}
	// if (params&&params.sort){
	// 	console.log(params.sort);
	// }
	if (params){
		var clonedParams = JSON.parse(JSON.stringify(params));
		if (clonedParams.filters){
			delete clonedParams.filters;
		}
		url = url + '?' + qs(clonedParams);
	}	
	var axiosOptions = {
		withCredentials: true,
		url : url,
		method : 'GET'
	}
	if (config.adminUrl.apis[source].method){
		axiosOptions.method = config.adminUrl.apis[source].method
	}
	if (data){
		axiosOptions.data = {data:data};
	}
	// console.log('xxxxx ', axiosOptions);
	return axios(axiosOptions);
}

function user(action, params, data){
	console.log('User config : ', config, data);
	var url = config.apiUrl.href+config.apiUrl.apis.member[action].path;
	if (params&&params.id){
		url = url + params.id;
	}
	var axiosOptions = {
		withCredentials: true,
		url : url,
		method : 'GET'
	}
	if (config.apiUrl.apis.member[action].method){
		axiosOptions.method = config.apiUrl.apis.member[action].method
	}
	if (data){
		axiosOptions.data = {data:data};
	}
	// console.log('xxxxx ', axiosOptions);
	return axios(axiosOptions);
}

function resource(source, params, data){
	console.log('Getting resource using : ', params);
	var url = config.apiUrl.href+config.apiUrl.resources[source].path;
	if (params&&params.id){
		url = url + params.id;
	}
	if (params&&params.filters){
		Object.keys(params.filters).forEach(function(key) {
			if (params.filters[key]){						
				if (Array.isArray(params.filters[key])){
					if (params.filters[key].length > 0){								
						var filters = [];
						params.filters[key].forEach(function(f){
							filters.push(f.value);
						});
						params.filter[key]={
							in : filters.join(',')
						};
					} else {
						if (params.filter[key]){
							delete params.filter[key];
						}
					}
				} else {
					if (params.filters[key].value){
						params.filter[key]=params.filters[key].value;
					} else {
						if (params.filters[key]){
							delete params.filter[key];
						}						
					}
				}
			} else {
				if (params.filter[key]){
					delete params.filter[key];
				}
			}
		});
		// console.log(resource, qs(params));
	}
	// if (params&&params.sort){
	// 	console.log(params.sort);
	// }
	if (params){
		var clonedParams = JSON.parse(JSON.stringify(params));
		if (clonedParams.filters){
			delete clonedParams.filters;
		}
		url = url + '?' + qs(clonedParams);
	}	
	var axiosOptions = {
		withCredentials: true,
		url : url,
		method : 'GET'
	}
	if (config.apiUrl.resources[source].method){
		axiosOptions.method = config.apiUrl.resources[source].method
	}
	if (data){
		axiosOptions.data = {data:data};
	}
	// console.log('xxxxx ', axiosOptions);
	return axios(axiosOptions);
}

export function getResource(source, params){
	return resource(source, params)
}

function job(action, params, data, key){
	var url = config.jobApiUrl.href+config.jobApiUrl.apis[action].path;
	if (params&&params.id){
		url = url + params.id;
	}
	var axiosOptions = {
		withCredentials: true,
		url : url,
		method : 'GET'
	}
	if (key){
		axiosOptions.headers = {
			'apiKey': key
		}
	}
	if (config.jobApiUrl.apis[action].method){
		axiosOptions.method = config.jobApiUrl.apis[action].method
	}
	if (data){
		axiosOptions.data = {data:data};
	}
	if (key){
		axiosOptions.data = data;
	}
	// console.log('xxxxx ', axiosOptions);
	return axios(axiosOptions);
}

export function signin(data, userType){
	if (userType&&userType=='admin'){
		return admin('login', false, data)
	} else {
		return user('login', false, data)
	}
}

export function signup(data){
	return user('signup', false, data)
}

export function registerEvent(data){
	return user('registerEvent', {id:data[0].id}, data)
}

export function registerFastRunner(data){
	return user('registerFastRunner', {id:data[0].id}, data)
}

export function verification(data){
	// console.log(data);
	return user('verification', {id:data.otpCode})
}

export function verifyPhone(data){
	// console.log(data);
	return user('verifyPhone', {id:data})
}

export function getTransaction(data){
	// console.log(data);
	return user('getTransaction', {id:data})
}

export function check(userType){
	if (userType&&userType=='admin'){
		console.log('XXX', userType);
		return admin('checkSession')
	} else {
		return user('checkSession')
	}
}

export function logout(){
	return user('logout')
}

export function checkEmail(data) {
	return user('checkEmail', false, data)
}

export function newPassword(params, data) {
	return user('newPassword', params, data)
}

export function resendCode(data) {
	return user('resendCode', false, data)
}

export function changeProfile(data) {
	// console.log('aaaa',data);
	return user('changeProfile', {id:data})
}

export function verifyData(fileId) {
	// console.log('aaaa',data);
	return user('verifyData', {id:fileId})
}

export function setLanguage(language) {
	// console.log('aaaa',data);
	return user('setLanguage', {id:language})
}

export function rejectInvitation(code) {
	// console.log('aaaa',data);
	return user('rejectInvitation', {id:code})
}

export function resetPassword(data) {
	return user('resetPassword', false, data)
}

export function setupPassword(data) {
	return user('setupPassword', false, data)
}

export function getProfile(){
	return user('getProfile')
}

export function validateId(data){
	return job('idValidation', false, data)
}

export function checkId(data){
	return job('checkValidation', false, data)
}

export function sendMail(data, key){
	return job('sendMail', false, data, key)
}

export function agreeNews(params){
	return user('agreeNews', params)
}

export function setProfile(data){
	// const tasks = [
	// 	// user('setProfile', false, data),
	// 	job('idValidation', false, data)
	// ];
	// return Promise.all(tasks)
	return user('setProfile', false, data);
}

export function addPhone(data){
	return user('addPhone', false, data)
}

export function checkout({transactionId, paymentType}){
	var idToParse = transactionId + '/' + paymentType
	return user('checkout', {id:idToParse})
}

export function approveBallot(data){
	return user('approveBallot', {id:data.mregOrderId})
}

export function rejectFastRunner(data){
	return user('rejectFastRunner', {id:data.mregOrderId})
}

export function validatorFileUpload(formData, onUploadProgress) {
	// console.log('masuk kah ? ', formData, onUploadProgress);
	var url = config.validatorUrl.href+config.validatorUrl.apis.upload.path;
	return axios.post(
		url,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			onUploadProgress: onUploadProgress
		}
	)
}

export function utilityFileUpload(formData, onUploadProgress) {
	// console.log('masuk kah ? ', formData, onUploadProgress);
	var url = config.utilityUrl.href+config.utilityUrl.apis.upload.path;
	return axios.post(
		url,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			onUploadProgress: onUploadProgress
		}
	)
}

export function extractId(data){
	var url = config.validatorUrl.href+config.validatorUrl.apis.extract.path;
	return axios.post(url, data)
}

export function getMembers(params){
	return adminResource('members',params)
}

export function getMember(params){
	return adminResource('member',params)
}

export function getRegistrations(params){
	return adminResource('registrations',params)
}

export function updateMemberData(params, data){
	return adminResource('memberUpdate', params, data)
}

// export function signup(data){
// 	return new Promise((resolve, reject) => {
// 		// commit('auth_request')
// 		user('signup', false, data)
// 			.then(resp => {
// 				console.log('S : ', resp);
// 				// const token = resp.data.token
// 				// const user = resp.data.user
// 				// localStorage.setItem('token', token)
// 				// axios.defaults.headers.common['Authorization'] = token
// 				// commit('auth_success', token, user)
// 				// resolve(resp)
// 			})
// 			.catch(err => {
// 				console.log('E : ', err);
// 				// commit('auth_error')
// 				// localStorage.removeItem('token')
// 				// reject(err)
// 			})
// 	})		
// }

// var testData = {
// 	"data": {
// 		"ptmmFullName": "Agus",
// 		"ptmmEmail": "agoes3@namague.com",
// 		"ptmmPhone": "087885555560",
// 		"ptmmGender": 1,
// 		"ptmmPassword": "mbelink"
// 	}
// };
// signup(testData)

// login({"data":{"email":"thomas.rubhez@gmail.com","password":"sa"}});

// user('checkSession')
// 	.then(function(sessionOut){
// 		console.log(sessionOut);
// 	})
// 	.catch(function(err){
// 		console.log(err);
// 	})

// this is aliased in webpack config based on server/client build
import { createAPI } from 'create-api'

// const logRequests = !!process.env.DEBUG_API
const logRequests = false

const api = createAPI({
	version: 'v1',
	config: {	
		baseURL: config.apiUrl.href,
		// timeout: 1000,
		paramsSerializer: function (params) {
			return utils.qs(params)
		},
		// headers: {'X-Custom-Header': 'STTCustomHead'}
	}
});

// api.params = {
// 	page : 1
// };

// warm the front page cache every 15 min
// make sure to do this only once across all requests

// if (api.onServer) {
// 	warmCache()
// }

function warmCache () {
	console.log('Do warm caching on server to reduce workload...');
	// fetchItems((api.cachedIds.top || []).slice(0, 30))
	// setTimeout(warmCache, 1000 * 60 * 15)
}


function fetch ({ resource, params}) {
	console.log(`fetching... ${resource}...`, params);
	// logRequests && console.log(`fetching ${child}...`)
	const cache = api.cachedItems;
	console.log('cache? ', cache);
	// if (cache && cache.has(child)) {
	// 	// console.log(`fetching ${child}...`)
	// 	// cache.reset();
	// 	// console.log('reset cache....');
	// 	// console.log(`cache hit for ${child}.`)
	// 	logRequests && console.log(`cache hit for ${child}.`)
	// 	return Promise.resolve(cache.get(child))
	// } else {
		return new Promise((resolve, reject) => {
			// resolve([])
	// 		console.log('Cache not found, fetching fresh data...')
			var p = {
				url : config.apiUrl.resources[resource].path,
				params : params
				// resource: resource,
				// params: {
				// }
			}
			// var resourceId = new Buffer(JSON.stringify({[resource]:params})).toString('base64');
			console.log('API request to ... ',p.url);
			api(p)
				.then((apiOut)=>{
					console.log('output request on client here... ',apiOut.data.data.length)
					resolve(apiOut.data)
				})
				.catch((err)=>{
					// console.log('err request on client... : ', err)
					reject(err);
				})
	// 		// api.child(child).once('value', snapshot => {
	// 		// 	const val = snapshot.val()
	// 		// 	// mark the timestamp when this item is cached
	// 		// 	if (val) val.__lastUpdated = Date.now()
	// 		// 	cache && cache.set(child, val)
	// 		// 	logRequests && console.log(`fetched ${child}.`)
	// 		// 	resolve(val)
	// 		// }, reject)
		})
	// }
}

export function fetchItemsByResource (resource, params) {
	console.log('Fetch items by resource... ', resource, params);

	return api.cachedIds && api.cachedIds[resource]
		? Promise.resolve(api.cachedIds[resource])
		: fetch({resource, params})
}

export function fetchItem (id) {
	return fetch(`item/${id}`)
}

export function fetchItems (ids) {
	console.log('Fetch all IDS',ids.length)
	return Promise.all(ids.map(id => fetchItem(id)))
}

export function fetchUser (id) {
	return fetch(`user/${id}`)
}

export function watchList (type, cb) {
	// let first = true
	// const ref = api.child(`${type}stories`)
	// const handler = snapshot => {
	// 	if (first) {
	// 		first = false
	// 	} else {
	// 		cb(snapshot.val())
	// 	}
	// }
	// ref.on('value', handler)
	// return () => {
	// 	ref.off('value', handler)
	// }
}



// WEBPACK FOOTER //
// src/api/index.js